<template>
  <div class=" tailor">
    <b-navbar class="navbar navbar-dark bg-orange-custom sticky-top">
      <a class="navbar-brand" href="#">Issues <i class="fa fa-comments"></i></a>
      <!-- <b-button v-b-tooltip.hover title="Status" pill variant="outline-light" v-on:click="statusFilterChange()" :disabled="!filteredFeatureList.length">{{statusFilter}}</b-button> -->
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-dropdown v-b-tooltip.hover title="User" variant="outline-light" :text="userFilter" size="sm" class="m-2" :disabled="!filteredFeatureList.length" right>
            <b-dropdown-item-button v-on:click="userFilterChange('User')">All</b-dropdown-item-button>
            <template v-if="currentUser">
              <b-dropdown-item-button v-on:click="userFilterChange(currentUser.fullName)">{{currentUser.fullName}}</b-dropdown-item-button>
            </template>

            <!-- <b-dropdown-item-button v-for="(item, index) in userFilterSet" :key="index" v-on:click="userFilterChange(item)">{{item}}</b-dropdown-item-button> -->
          </b-dropdown>
          <b-dropdown v-b-tooltip.hover title="Status" variant="outline-light" :text="statusFilter" size="sm" class="m-2" :disabled="!filteredFeatureList.length" right>
            <b-dropdown-item-button v-on:click="statusFilterChange('Status')">All</b-dropdown-item-button>
            <b-dropdown-item-button v-for="(item, index) in statusFilterSet" :key="index" v-on:click="statusFilterChange(item)">{{item}}</b-dropdown-item-button>
          </b-dropdown>
          <b-dropdown v-b-tooltip.hover title="Discipline" variant="outline-light" :text="disciplineFilter" size="sm" class="m-2" :disabled="!filteredFeatureList.length" right>
            <b-dropdown-item-button v-on:click="disciplineFilterChange('Discipline')">All</b-dropdown-item-button>
            <b-dropdown-item-button v-for="(item, index) in disciplineFilterSet" :key="index" v-on:click="disciplineFilterChange(item)">{{item}}</b-dropdown-item-button>
          </b-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div class="row">
      <div class="col list-group">
        <template v-if="filteredFeatureList.length">
          <!-- <div v-for="item in filteredFeatureList" :key="item.objectId"> -->
            <a href="#" v-for="item in filteredFeatureList" :key="item.objectId" class="list-group-item list-group-item-action" v-on:click="selectIssueFromList(item.objectId)">
              <div class="row">
                <div class="col-1 ml-3">
                  <i class="fa fa-user"></i>
                </div>
                <div class="col-10">
                  <div class="d-flex w-100 justify-content-between">
                    <p style="margin-bottom: 0.25rem;"><span class="badge badge-secondary badge-pill badge-custom">{{item.objectId}}</span><small> {{item.createdBy}}</small></p>
                    <small class="text-muted">{{getFormattedDate(item.date)}}</small>


                  </div>
                  <div class="d-flex w-100 justify-content-between">
                    <p class="mb-0 font-weight-normal">
                      <small>"{{item.requestDetails.length > 20 ? item.requestDetails.substring(0, 30) + '...' : item.requestDetails}}"</small>
                      <!-- <small><b>Issue Id: {{item.objectId}}</b> "{{issueCommentList.filter(obj => { return obj.objectId == item.objectId })[0].comments[0].comment_details > 0?issueCommentList.filter(obj => { return obj.objectId == item.objectId })[0].comments[0].comment_details: "none"}}"</small> -->
                    </p>
                    <p style="margin-bottom: 0.25rem;">
                      <small class="text-muted">{{item.discipline}}</small>&nbsp;&nbsp;
                      <template v-if="item.approvalStatus == 'Approved'">
                        <span class="badge badge-success badge-pill">{{item.approvalStatus}}</span>
                      </template>
                      <template v-else>
                        <span class="badge badge-danger badge-pill">{{item.approvalStatus}}</span>
                      </template>
                    </p>
                  </div>

                </div>
              </div>
            </a>
          <!-- </div> -->

        </template>
        <template v-else>
          <li class="list-group-item">{{loadingStatus}}</li>
        </template>

      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
import { loadModules } from 'esri-loader';
import {baseApiUrl} from "../../config.js"
import axios from "axios"

export default {
  name: 'SideMenu',
  data () {
    return {
      view: null,
      // webscene: this.$store.state.mapModule.mapWebScene,
      // issueFeatureList: this.$store.state.mapModule.initialIssues,
      // issueCommentList: this.$store.state.mapModule.issueComments,
      // currentIssueId: null,
      issueIds: [],
      issueSceneLayer: null,
      highlight: null,
      highlightArray: [],
      // disciplineFilterSet: ['Design Management','Civil','Road Design','Drainage','Traffic','Utilities','Structures','Geotech','Tunnel','Ventilation','Design & Engineering','GIS','Project Management','Ground Engineering','CAD','ITS Surface','M&E'],
      // disciplineFilterSet: ['Engineering', 'Transport', 'Environment'],
      disciplineFilterSet: ['Environment', 'GIS', 'CLARA'],
      disciplineFilter: "Discipline",
      statusFilterSet: ['Approved','Pending'],
      statusFilter: "Status",
      userFilterSet: [],
      userFilter: "User",
      loadingStatus: "Loading..."
    }
  },
  computed: {
    webscene: {
      get() {
        return this.$store.state.mapModule.mapWebScene
      }
    },
    currentIssueId: {
      get() {
        return this.$store.state.mapModule.currentIssueId
      }
    },
    issueFeatureList: {
      get() {
        return this.$store.state.mapModule.initialIssues
      }
    },
    issueLayerId: {
      get() {
        return this.$store.state.mapModule.staticIssueLayerId
      }
    },
    currentUser: {
      get() {
        if(this.$store.state.mapModule.user){
          return this.$store.state.mapModule.user
        }
        else {
          return false;
        }
      }
    },
    filteredFeatureList: {
      get() {
        console.log(this.currentUser);
        var finalList = this.issueFeatureList
        if (this.disciplineFilter == "Discipline") {
          finalList =  this.issueFeatureList
        }
        else {
          finalList = this.issueFeatureList.filter(obj=>obj.discipline == this.disciplineFilter)
        }
        if (this.statusFilter != "Status") {
          finalList = finalList.filter(obj=>obj.approvalStatus == this.statusFilter)
        }
        if (this.userFilter != "User") {
          finalList = finalList.filter(obj=>obj.createdBy == this.userFilter)
        }
        // this.userFilterSet= [this.currentUser.fullName]
        return finalList
      }
    },
    webSceneLoadedFlag: {
      get() {
        return this.$store.state.mapModule.mapWebSceneLoadFlag
      }
    }
  },
  watch: {
    webSceneLoadedFlag: function() {
      const current = this
      console.log("webscene watch1");

      if (current.webSceneLoadedFlag) {
        console.log("webscene watch2");
        // current.loadIssueList()
        console.log(current.webSceneLoadedFlag);
        // current.userFilterSet= [current.$store.state.mapModule.user.fullName]
        current.loadIssueList_noArcGIS()
      }
    },
    issueFeatureList: function() {
      const current = this
      const vue = document.getElementById("map").__vue__
      const view = vue.view
      console.log(current.issueFeatureList);
      if (current.issueFeatureList && current.webSceneLoadedFlag) {
        console.log(window.location.href.split("/"));
        var objectId = window.location.href.split("/")[window.location.href.split("/").length - 1]
        if (!isNaN(parseInt(objectId))) {
          // current.selectIssueFromList(objectId)
          view.whenLayerView(current.issueSceneLayer).then(()=>{
            console.log("SceneView load complete = " + view.isResolved());
            current.selectIssueFromList(parseInt(objectId))
          })
        }
      }
    }
  },
  methods: {
    loadIssueList_noArcGIS: function() {
      const current = this
      const vue = document.getElementById("map").__vue__
      const sceneView = vue.view
      // current.issueSceneLayer = sceneView.map.allLayers.filter(function(item) {
      //   return item.id === current.issueLayerId;
      // }).items[0];
      current.issueSceneLayer = sceneView.map.findLayerById(current.issueLayerId);
      // current.issueSceneLayer = current.webscene.allLayers.filter(function(item) {
      //   return item.id === current.issueLayerId;
      // }).items[0];
      console.log(current.issueSceneLayer);
      current.$store.commit("mapModule/resetInitialIssues")
      current.issueSceneLayer.graphics.items.forEach(item => {
        // console.log(item.attributes);
        var featureObject = {}
        featureObject["objectId"] = item.attributes.id
        // featureObject["globalId"] = item.attributes.globalid
        featureObject["discipline"] = item.attributes.discipline
        featureObject["priority"] = item.attributes.priority
        featureObject["createdBy"] = item.attributes.issueCreatedBy
        featureObject["userName"] = item.attributes.userName
        featureObject["addressedTo"] = item.attributes.addressedTo
        featureObject["issueType"] = item.attributes.issueType
        // featureObject["issue"] = item.attributes.details
        featureObject["requestDetails"] = item.attributes.requestDetails
        featureObject["approvalStatus"] = item.attributes.approvalState
        featureObject["date"] = item.attributes.date
        featureObject["requestCreated"] = item.attributes.requestCreated
        featureObject["responseRequiredBy"] = item.attributes.responseRequiredBy
        featureObject["updateBy"] = item.attributes.updateBy
        // featureObject["dueDate"] = item.attributes.dueDate
        featureObject["fileName"] = item.attributes.fileName
        featureObject["fileId"] = item.attributes.fileId
        // current.issueFeatureList.push(featureObject)
        current.issueIds.push(item.attributes.id)
        current.$store.commit("mapModule/insertInitialIssues", featureObject)

      })
      current.loadingStatus = (current.issueSceneLayer.graphics.items.length==0)?"No Data Found":""
      current.$store.dispatch("mapModule/fetchIssueComments", {objectIds: current.issueIds})
      console.log(current.issueSceneLayer);

    },
    selectIssueFromList:function(issueId) {
      const current = this
      const vue = document.getElementById("map").__vue__
      const view = vue.view
      console.log(issueId);
      current.highlightArray.forEach(item=>{
        item.remove()
      })
      current.issueSceneLayer = view.map.findLayerById(current.issueLayerId);
      // store the issueId and the content of the issue/comments on the store variables
      // selected Issue and selected comments
      // if (!current.issueSceneLayer) {
      //   current.issueSceneLayer = view.map.allLayers.filter(function(item) {
      //     return item.id === current.issueLayerId;
      //   }).items[0];
      // }
      if (current.currentIssueId == issueId) {
        current.$store.commit("mapModule/clearAttachments")
        current.$store.commit("mapModule/setCurrentIssueId", null)
        current.toggleFlexContainer()
      }
      else {
        console.log(current.currentIssueId);
        current.closeFlexContainer()
        current.$store.commit("mapModule/clearAttachments")
        current.$store.dispatch("mapModule/setCurrentIssueDetails", issueId)
        // current.getFlexData(issueId)
        console.log(current.currentIssueId);
        current.openFlexContainer()
        // const vue = document.getElementById("map").__vue__
        // const view = vue.view
        console.log(vue);
        console.log(view);
        loadModules(["esri/tasks/support/Query"],{ css: true })
        .then(([Query]) => {
          console.log(current.issueSceneLayer);
          view.whenLayerView(current.issueSceneLayer).then(function(issueLayerView){
            var selectedFeature = current.issueSceneLayer.graphics.items.filter(obj=>{
              return obj.attributes.id === issueId
            })[0]
            console.log(selectedFeature);
            if (selectedFeature) {
              current.highlightArray[issueId] = issueLayerView.highlight(selectedFeature);
              var center = selectedFeature.geometry
              var tilt = view.camera.tilt
              view.goTo({
                speedFactor: 0.5,
                zoom: 21,
                tilt: tilt,
                center: center
              });
            }
            else {
              current.closeFlexContainer()
            }
            // if (current.highlight) {
            //   current.highlight.remove();
            // }
            // current.highlight = issueLayerView.highlight([issueId]);
          })



        })

      }
      // connect to database, get the data, store to state, then open the flexContainer
    },
    clearTextData:()=>{
      var comment = document.getElementById("newCommentTextArea")
      if (comment) {
        comment.innerHTML = ""
        comment.value = ""
      }
    },
    toggleFlexContainer: function() {
      this.clearTextData()
      var flexContainer = document.getElementById("flexContainer")
      var map = document.getElementById("mapContainer")
      map.classList.toggle("col-9")
      flexContainer.classList.toggle("displayNone")
      map.classList.toggle("col-6")
    },
    closeFlexContainer: function() {
      this.clearTextData()
      var flexContainer = document.getElementById("flexContainer")
      var map = document.getElementById("mapContainer")
      flexContainer.classList.add("displayNone")
      map.classList.remove("col-6")
      map.classList.add("col-9")
    },
    openFlexContainer: function() {
      var flexContainer = document.getElementById("flexContainer")
      var map = document.getElementById("mapContainer")
      map.classList.remove("col-9")
      map.classList.add("col-6")
      flexContainer.classList.remove("displayNone")
    },
    disciplineFilterChange: function(selection) {
      this.disciplineFilter = selection
      if (this.filteredFeatureList.length == 0) {
        this.disciplineFilterChange("Discipline")
        this.$notify({
          group: 'errors',
          title: "Empty List",
          type: 'error',
          text: "No items in the list for "+selection,
          width: 500,
          duration: 1500
        })
      }
      else {
        this.featureFilter()
      }
    },
    statusFilterChange: function(selection) {
      // ++this.statusFilterCounter
      // this.statusFilter = this.statusFilterSet[this.statusFilterCounter%3]
      this.statusFilter = selection
      if (this.filteredFeatureList.length == 0) {
        this.statusFilterChange("Status")
        this.$notify({
          group: 'errors',
          title: "Empty List",
          type: 'error',
          text: "No items in the list for "+selection,
          width: 500,
          duration: 1500
        })
      }
      else {
        this.featureFilter()
      }
    },
    featureFilter: function(){
      const current = this
      var filterLayer = {
        user: current.userFilter == "User"? "": current.userFilter,
        discipline: current.disciplineFilter == "Discipline"? "": current.disciplineFilter,
        status: current.statusFilter == "Status" ? "" : current.statusFilter
      }
      var objectId = window.location.href.split("/")[window.location.href.split("/").length - 1]
      if(current.issueFeatureList && current.webSceneLoadedFlag && isNaN(parseInt(objectId))){
        const vue = document.getElementById("map").__vue__
        const sceneView = vue.view
        var issueSceneLayer = sceneView.map.findLayerById(current.issueLayerId)
        current.$store.dispatch("mapModule/fetchIssueLayer", filterLayer).then(currentIssueLayer=>{
          sceneView.map.remove(issueSceneLayer);
          sceneView.map.add(currentIssueLayer);
        })
      }
    },
    userFilterChange: function(selection) {
      // ++this.statusFilterCounter
      // this.statusFilter = this.statusFilterSet[this.statusFilterCounter%3]
      this.userFilter = selection
      if (this.filteredFeatureList.length == 0) {
        this.userFilterChange("User")
        this.$notify({
          group: 'errors',
          title: "Empty List",
          type: 'error',
          text: "No items in the list for "+selection,
          width: 500,
          duration: 1500
        })
      }
      else {
        this.featureFilter()
      }
    },
    getFormattedDate: function(dateItem) {
      let date = new Date(dateItem)
      let year = date.getFullYear().toString();
      let month = date.getMonth() + 1;
      month = month.toString().padStart(2, '0');
      let day = date.getDate().toString().padStart(2, '0');
      let hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
      let am_pm = date.getHours() >= 12 ? "pm" : "am";
      hours = hours < 10 ? "0" + hours : hours;
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let time = hours + ":" + minutes + " " + am_pm;
      return year + '-' + month + '-' + day + " " + time;
    },
  },
}
</script>

<style>
  .panel-result {
    cursor: pointer;
    margin: 2px 0;
  }

  .panel-result:hover,
  .panel-result:focus,
  .panel-result.selected {
    background-color: rgba(200, 200, 200, 0.6);
  }
  .tailor {
    height: 93vh;
    max-height: 93vh;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .badge-custom {
    padding-right: 0.45em !important;
    padding-left: 0.45em !important;
    padding: 0.45em 0.45em !important;
  }

  .bg-orange-custom {
    background-color: #E66200 !important;
  }

</style>
